// extracted by mini-css-extract-plugin
export default {"container":"gauge_container__KguXH","icon":"gauge_icon__RTl6X"};